import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  makeStyles,
  Button,
  Paper,
  Grid,
} from "@material-ui/core";
import Page from "src/components/Page";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import { Alert } from "@material-ui/lab";
import { kmMessages, getSystemLabel } from "src/constant/Messages";
import { apiEndpoints, apiGetRequest, apiPostRequest } from "src/utils/api/api";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
  },
  massagebox: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  firstlevtintend: {
    textIndent: "-1.19em",
    textDecoration: "none",
  },
  seclevtintend: {
    textIndent: "-1.19em",
    marginLeft: theme.spacing(3),
  },
  secondol: {
    paddingLeft: theme.spacing(2),
    " & li::marker": {
      content: "attr(point-attr)",
    },
    " & li": {
      paddingLeft: "0.3em",
    },
  },
  thirdol: {
    paddingLeft: theme.spacing(4),
    " & li::marker": {
      content: "attr(point-attr)",
    },
    " & li": {
      paddingLeft: "0.3em",
    },
  },

  img: {
    margin: "auto",
    display: "block",
    [theme.breakpoints.up("lg")]: {
      maxWidth: "42%",
    },
    [theme.breakpoints.down("lg")]: {
      maxWidth: "52%",
    },
    [theme.breakpoints.down("md")]: {
      maxWidth: "70%",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "95%",
    },
    maxHeight: "100%",
  },
}));

const DeclarationTasksView = ({
  globalData,
  setAuthorized,
  setCurrentUserData,
  enableGlobalLoader,
  disableGlobalLoader,
  displaySnackbar,
  setLogoutUser,
  ...rest
}) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const getAcceptActionName = () => {
    switch (rest.kmcontext) {
      case "member":
        return "declaration_mem_tasks";
      case "observer":
        return "declaration_obs_tasks";
      default:
        return null;
    }
  };

  const acceptDeclarationTasks = () => {
    enableGlobalLoader();

    apiPostRequest(
      apiEndpoints.setConsent.path,
      { action: getAcceptActionName() },
      true
    )
      .then((data) => {
        disableGlobalLoader();
        apiGetRequest(apiEndpoints.getLoggedUser.path, true)
          .then((data) => {
            disableGlobalLoader();
            setAuthorized(true);
            setCurrentUserData(data);
            navigate("/");
          })
          .catch((error) => {
            disableGlobalLoader();
            if (error.response) {
              if (error.response.status === 403) {
                if (error.response.data) {
                  if (
                    error.response.data.code === "MEMBER_TASKS_NOT_ACCEPTED"
                  ) {
                    navigate("/deklaracjazadaniacz");
                    return;
                  } else if (
                    error.response.data.code === "OBSERVER_TASKS_NOT_ACCEPTED"
                  ) {
                    navigate("/deklaracjazadaniaobs");
                    return;
                  }
                }
              }
            }
            displaySnackbar({
              isOpen: true,
              severity: "error",
              autoHideDuration: 10000,
              message: kmMessages.error.global.apierror,
            });
            setLogoutUser();
          });
      })
      .catch((error) => {
        disableGlobalLoader();
        displaySnackbar({
          isOpen: true,
          severity: "error",
          autoHideDuration: 10000,
          message: kmMessages.error.global.apierror,
        });
        setLogoutUser();
      });
  };

  const noAcceptDeclarationTasks = () => {
    setLogoutUser();
  };

  const getDocumentTitleText = () => {
    switch (rest.kmcontext) {
      case "member":
        return `OŚWIADCZENIE I DEKLARACJA CZŁONKA/ZASTĘPCY CZŁONKA KOMITETU MONITORUJĄCEGO ${getSystemLabel(
          "programUpperYears",
          globalData.systemInfo
        )}`;
      case "observer":
        return `OŚWIADCZENIE I DEKLARACJA OBSERWATORA W KOMITECIE MONITORUJĄCYM ${getSystemLabel(
          "programUpperYears",
          globalData.systemInfo
        )}`;
      default:
        disableGlobalLoader();
        displaySnackbar({
          isOpen: true,
          severity: "error",
          autoHideDuration: 10000,
          message: kmMessages.error.global.apierror,
        });
        setLogoutUser();
    }
  };

  return (
    <Page className={classes.root} title={getDocumentTitleText()}>
      <Container maxWidth="lg">
        <Box
          display="flex"
          flexWrap="wrap"
          alignContent="center"
          p={1}
          css={{ height: "4vh" }}
        ></Box>
        <Box
          display="flex"
          flexDirection="column"
          height="100%"
          justifyContent="center"
        >
          <Box mb={1}>
            {getSystemLabel(
              "programDeclarationAccept",
              globalData.systemInfo
            ) ? (
              <Alert severity="warning" className={classes.massagebox}>
                <div>
                  {getSystemLabel(
                    "programDeclarationAccept",
                    globalData.systemInfo
                  )}
                </div>
              </Alert>
            ) : (
              <></>
            )}
            <Paper>
              <Box p={2} pl={5}>
                <Typography
                  color="textPrimary"
                  component="h1"
                  align="center"
                  variant="h2"
                  paragraph
                >
                  {getDocumentTitleText()}
                </Typography>
                {/* <Typography component="p" display="block" paragraph> */}
                {rest.kmcontext === "member" ? (
                  <>
                    <Typography component="p" display="block" paragraph>
                      Oświadczam, że zapoznałem/zapoznałam się z zadaniami
                      Komitetu Monitorującego określonymi w Uchwale Nr
                      35/324/2015 Zarządu Województwa Podlaskiego z dnia 8
                      kwietnia 2015 r. (z późn. zm.) w sprawie powołania
                      Komitetu Monitorującego{" "}
                      {getSystemLabel("programYears", globalData.systemInfo)} i
                      z trybem pracy Komitetu Monitorującego{" "}
                      {getSystemLabel("programYears", globalData.systemInfo)},
                      określonym w Regulaminie KM $
                      {getSystemLabel(
                        "programShortcutYears",
                        globalData.systemInfo
                      )}{" "}
                      z dnia 29 kwietnia 2015 r. (z późn.zm).
                    </Typography>
                    <Typography component="p" display="block" paragraph>
                      Deklaruję gotowość do rzetelnej i bezstronnej realizacji
                      zadań wynikających z udziału w Komitecie Monitorującym
                      {getSystemLabel(
                        "programYears",
                        globalData.systemInfo
                      )}{" "}
                      oraz znajomość przysługujących mi praw i powierzonych mi
                      obowiązków, których wykaz stanowi załącznik Nr 3 do
                      Regulaminu KM $
                      {getSystemLabel(
                        "programShortcutYears",
                        globalData.systemInfo
                      )}{" "}
                      z dnia 29 kwietnia 2015 r. (z późn.zm).
                    </Typography>
                    <Typography component="p" display="block" paragraph>
                      Zobowiązuję się do ujawnienia ewentualnego konfliktu
                      interesów dotyczącego mojej osoby i wyłączenia się z
                      podejmowania decyzji w zakresie, którego ten konflikt może
                      dotyczyć.
                    </Typography>
                  </>
                ) : rest.kmcontext === "observer" ? (
                  <>
                    <Typography component="p" display="block" paragraph>
                      Oświadczam, że zapoznałem/zapoznałam się z zadaniami
                      Komitetu Monitorującego określonymi w Uchwale Nr
                      35/324/2015 Zarządu Województwa Podlaskiego z dnia 8
                      kwietnia 2015 r. (z późn. zm.) w sprawie powołania
                      Komitetu Monitorującego{" "}
                      {getSystemLabel("programYears", globalData.systemInfo)} i
                      z trybem pracy Komitetu Monitorującego{" "}
                      {getSystemLabel("programYears", globalData.systemInfo)},
                      określonym w Regulaminie KM $
                      {getSystemLabel(
                        "programShortcutYears",
                        globalData.systemInfo
                      )}{" "}
                      z dnia 29 kwietnia 2015 r. (z późn. zm.).
                    </Typography>
                    <Typography component="p" display="block" paragraph>
                      Deklaruję gotowość do rzetelnej i bezstronnej realizacji
                      zadań wynikających z udziału w charakterze Obserwatora w
                      pracach Komitetu Monitorującego{" "}
                      {getSystemLabel("programYears", globalData.systemInfo)}{" "}
                      oraz znajomość przysługujących mi praw i powierzonych mi
                      obowiązków określonych w Regulaminie KM $
                      {getSystemLabel(
                        "programShortcutYears",
                        globalData.systemInfo
                      )}{" "}
                      z dnia 29 kwietnia 2015 r. (z późn.zm).
                    </Typography>
                  </>
                ) : (
                  <></>
                )}
              </Box>
            </Paper>
            <Box>
              <Paper>
                <Box mt={1} p={1}>
                  <Typography component="p" display="block">
                    Czy akceptujesz treść powyższego oświadczenia?
                  </Typography>
                </Box>
              </Paper>
            </Box>
            <Box my={2}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Paper className={classes.paper}>
                    <Button
                      color="primary"
                      fullWidth
                      size="large"
                      onClick={noAcceptDeclarationTasks}
                    >
                      Nie
                    </Button>
                  </Paper>
                </Grid>
                <Grid item xs={6}>
                  <Paper className={classes.paper}>
                    <Button
                      color="primary"
                      fullWidth
                      size="large"
                      variant="contained"
                      onClick={acceptDeclarationTasks}
                    >
                      Tak
                    </Button>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </Container>
      <Box display="flex" alignItems="flex-end" flexGrow={1} p={1}>
        <Box display="flex" flexDirection="column">
          <img
            className={classes.img}
            alt="Logo UE stopka"
            src="/static/images/logo_ue_main.jpg"
          />
          <Typography
            variant="caption"
            gutterBottom
            color="textSecondary"
            align="center"
            component="p"
          >
            Aplikacja współfinansowana przez Unię Europejską ze środków
            Europejskiego Funduszu Społecznego w ramach Regionalnego Programu
            Operacyjnego Województwa Podlaskiego na lata 2014-2020
          </Typography>
          <Typography
            color="textPrimary"
            variant="subtitle2"
            align="center"
            component="p"
          >
            2021 © Urząd Marszałkowski Województwa Podlaskiego
          </Typography>
        </Box>
      </Box>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  globalData: state.globalData,
});

const mapDispatchToProps = (dispatch) => ({
  setAuthorized: (isAuthorized) =>
    dispatch(actions.setAuthorized(isAuthorized)),
  setCurrentUserData: (currentUserData) =>
    dispatch(actions.setCurrentUser(currentUserData)),
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  displaySnackbar: (snackBarParameters) =>
    dispatch(actions.displaySnackbar(snackBarParameters)),
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeclarationTasksView);
